import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useDownloadSummaryData } from "@/lib/api/otc";
import { ReportCard, ReportDownloadLink } from "./ReportCard";

/**
 * Summary Report — no filters. Generate downloads a single link.
 */
export function SummaryReportCard() {
  const { toast } = useToast();
  const downloadDataLinkFunc = useDownloadSummaryData();
  const [link, setLink] = useState<string | undefined>(undefined);
  const [isDownloading, setIsDownloading] = useState(false);

  const onGenerate = async () => {
    if (isDownloading) return;
    // Clear any prior result for this report before running again.
    setLink(undefined);
    setIsDownloading(true);

    const result = await downloadDataLinkFunc();

    if (!result.success) {
      toast({ title: "Failed to generate", description: "" });
    } else {
      setLink(result.data.link);
    }

    setIsDownloading(false);
  };

  return (
    <ReportCard
      title="Summary Report"
      description="Generate a summary report across all OTC contracts."
      isDownloading={isDownloading}
      onGenerate={onGenerate}
      hasResults={!!link}
      linkContent={link ? <ReportDownloadLink href={link} label="Download Report" /> : null}
    />
  );
}
